export default __webpack_public_path__ + "static/AlgoFilipino-55af007bd867f4aa2975865023d8647e.png";